import React from "react";

function splitUserName(userName = "") {
    const parts = String(userName).trim().split(/\s+/).filter(Boolean);
    if (parts.length <= 1) {
        return { firstLine: parts[0] || "", secondLine: "" };
    }
    if (parts.length === 2) {
        return { firstLine: parts[0], secondLine: parts[1] };
    }
    return {
        firstLine: parts.slice(0, 2).join(" "),
        secondLine: parts.slice(2).join(" "),
    };
}

export default function PortalSidebarShell({
    portalSubtitle,
    userLabel,
    userName,
    mobileSidebarOpen,
    desktopSidebarHidden,
    sidebarToggleLabel,
    onToggleSidebar,
    onCloseSidebar,
    children,
}) {
    const { firstLine, secondLine } = splitUserName(userName);

    return (
        <aside
            className={`portal-sidebar teacher-portal-sidebar bg-white border-end shadow-sm backoffice-aside flex-shrink-0 ${desktopSidebarHidden ? "teacher-sidebar-desktop-hidden" : ""} ${mobileSidebarOpen
                ? "position-fixed top-0 start-0 h-100 active teacher-portal-sidebar--open"
                : "sidebar-responsive"
                }`}
            style={{
                zIndex: 1050,
                transition: "transform 0.3s ease",
                width: "230px",
                minWidth: "230px",
            }}
        >
            <button
                type="button"
                className="menu-panel close-sidebar-btn teacher-sidebar-close-btn"
                onClick={onToggleSidebar}
                aria-label={sidebarToggleLabel}
                title={sidebarToggleLabel}
            >
                <i className="ri-close-line" aria-hidden />
            </button>

            <div className="p-3 div-navadmin d-flex justify-content-between align-items-center">
                <button className="navbar-logo-desktop" onClick={onCloseSidebar}>
                    <div className="d-flex align-items-center gap-2 block-navadmin">
                        <img src="/img/somnus.webp" alt="Somnus" className="navbar-logo" />
                        <div className="tittle-navadmin">
                            <div>
                                <span className="logo-somnus">Somnus</span>
                            </div>
                            <div className="subtittle-navadmin">
                                <span className="text-muted">{portalSubtitle}</span>
                            </div>
                        </div>
                    </div>
                </button>
            </div>

            <div className="px-3 pt-2 pb-3 admin-current-user border-bottom">
                <div className="admin-current-user-label">{userLabel}</div>
                <div className="admin-current-user-name" title={userName}>
                    <span className="admin-current-user-name-line">{firstLine}</span>
                    {secondLine ? (
                        <span className="admin-current-user-name-line">{secondLine}</span>
                    ) : null}
                </div>
            </div>

            <nav className="nav flex-column p-3 gap-1 class-color colum-navbar">{children}</nav>
        </aside>
    );
}
